import React, { useContext, useEffect, useState } from "react";
import "./ECSGeneration.css";
import { apiurl } from "../../../../path";
// import Application from "../../../StateContext/Application.js";
import Application from "../../StateContext/Application.js";
import {
  ApprovePay32,
  AvailableReleaseAmount,
  Balance,
  BillApprovalBlue32,
  Search32,
  SelectedDemandAmount,
  TotalAmountRelease,
  TotalLimitAlloted123,
  TotalProjectCost11,
  TotalWorkOrders,
} from "../../../../public/LoginImages/importimages.js";
import { useLanguage } from "../../../../lang/langcontext/LanguageContext.js";
import GooglePagination from "../../styles/GooglePagination";

const OldECSGeneration = () => {
  const { language, toggleLanguage, t } = useLanguage();
  const operation = useContext(Application);

  const {
    GetProjectInfo,
    GetBudgetHeadInfo,
    DemandCreation,
    GetOldBillsApproval,
    ApproveBills,
    GetTotalAmountAvailbaleInBank,
    CreateToken,
    Usermenu,
    Getyears,
    GenerateBankFile,
  } = operation;

  const [projectId, setProjectId] = useState([]);
  const [ALLtableData, setALLTableData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [getAvailableBankBalance, SetAvailableBankBalance] = useState([]);
  const [BankBalance, setBankBalance] = useState([]);
  const [CountBalance, setCountBalance] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [showspecific, setShowSpecific] = useState(0);
  const [selectedDemandID, setSelectedDemandID] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const [
    fetchSpecificDemandDeductionDetail,
    setfetchSpecficDemandDeductionDetail,
  ] = useState([]);
  // const [filteredBills, setFilteredBills] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState({});

  const [currentPage, setCurrentPage] = useState(1);
  const [showAll, setShowAll] = useState(false);
  const billsPerPage = showAll ? tableData.length : 10;

  const totalPages = Math.ceil(tableData?.length / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  //  const sortedBills = Array.isArray(tableData)? tableData.slice() // ✅ prevent state mutation
  // .sort((a, b) => new Date(b.Date) - new Date(a.Date))
  //         : [];
  const sortedBills = tableData;
  const currentBills = sortedBills?.slice(indexOfFirstBill, indexOfLastBill);
  // const currentBills = tableData?.slice(indexOfFirstBill, indexOfLastBill);

  const [data, setData] = useState({
    ProjectName: "",
    ProjectID: "",
    PIU: "",
    AvaiableReleaseAmount: 0,
    SelectedDemandAmount: 0,
    Balance: 0,
  });

  const [hide, sethide] = useState(true);
  const [Etoken, SetEtoken] = useState(false);
  const [GenerateToken, SetGenerateToken] = useState(true);
  const [AdminData, setAdminData] = useState([]);

  async function GenerateTokenFor(e) {
    e.preventDefault();
    let data = await CreateToken("Demand Approval");
    document.getElementById("tokencopys").innerText = data;
    SetEtoken(data);
    sethide(false);
  }

  const HandleChangeData = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const FetchData = async () => {
    try {
      let res = await GetOldBillsApproval("GetRecordsforECS");
      let res1 = await GetProjectInfo("null", "all");

      let proposalData = res.map((val) => ({
        ProjectId: val.MainWorkOrderID,
        ProjectName: val.MainWorkOrderID,
      }));

      const seen = new Set();

      const uniqueProposalData = proposalData.filter((item) => {
        const key = item.ProjectId;
        return seen.has(key) ? false : seen.add(key);
      });

      setProjectId(uniqueProposalData);

      console.log("Propdal data *************", proposalData);
      setTableData(res);
      console.log("response ", res);
      setALLTableData(res);
      console.log(res);
      // setHeadID(res1);
    } catch (err) {
      console.log(err);
    }
  };

  //For Fetching Admin details
  const GetAdminData = async () => {
    try {
      let res = await Usermenu();
      console.log(res);
      setAdminData(res.Data);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    FetchData();
    GetTotalAmountAvailableInBank();
    GetAdminData();
  }, []);

  const [selectedBills, setSelectedBills] = useState([]);
  const [loading, setLoading] = useState(false);

  // const handleCheckboxChange = (id) => {

  //   setSelectedBills((prevSelected) =>
  //     prevSelected.includes(id)
  //       ? prevSelected.filter((ProjectID) => ProjectID !== id) // Remove if already selected
  //       : [...prevSelected, id] // Add if not selected

  //   );
  // };

  //   const handleCheckboxChange = (id) => {
  //     const bill = tableData.find(b => b.DemandGenerationID === id);
  //     const amount = Number(bill.BillAmount);
  // if (
  //   AdminData.Department_Name === "State" &&
  //   (AdminData.RoleID !== 24)&&
  //   !uploadedFiles[id]
  // ) {
  //   alert("Please Upload Order file first!");
  //   return;
  // }
  //     setSelectedBills((prevSelected) => {
  //       let updated;
  //       if (prevSelected.includes(id)) {
  //         updated = prevSelected.filter((item) => item !== id);
  //         setData(prev => ({
  //           ...prev,
  //           SelectedDemandAmount: prev.SelectedDemandAmount - amount
  //         }));
  //       } else {
  //         updated = [...prevSelected, id];
  //         setData(prev => ({
  //           ...prev,
  //           SelectedDemandAmount: prev.SelectedDemandAmount + amount
  //         }));
  //       }
  //       return updated;
  //     });
  //   };
  const handleCheckboxChange = (id) => {
    const bill = tableData.find((b) => b.DemandGenerationID === id);

    const amount = Number(bill.BillAmount);

    // Upload Work validation
    if (
      AdminData.Department_Name === "State" &&
      AdminData.RoleID != 24 &&
      !uploadedFiles[id]
    ) {
      alert("Please upload work file first!");
      return;
    }

    setSelectedBills((prevSelected) => {
      // Existing selected bill objects
      const selectedBillObjects = tableData.filter((b) =>
        prevSelected.includes(b.DemandGenerationID),
      );

      // District validation
      if (prevSelected.length > 0 && !prevSelected.includes(id)) {
        const firstDistrict = selectedBillObjects[0]?.District;

        if (firstDistrict !== bill.District) {
          alert("You can select bills from the same district only!");
          return prevSelected;
        }
      }

      let updated;

      if (prevSelected.includes(id)) {
        updated = prevSelected.filter((item) => item !== id);

        setData((prev) => ({
          ...prev,
          SelectedDemandAmount: prev.SelectedDemandAmount - amount,
        }));
      } else {
        updated = [...prevSelected, id];

        setData((prev) => ({
          ...prev,
          SelectedDemandAmount: prev.SelectedDemandAmount + amount,
        }));
      }

      return updated;
    });
  };
  console.log("selectedbills", selectedBills);

  // const approveSelected = async () => {
  //   if (selectedBills.length === 0) {
  //     alert('No bills selected for approval!');
  //     return;
  //   }
  //   console.log(selectedBills);
  //   setLoading(true); // Start loader
  //   try {
  //     let response = await ApproveBills(selectedBills, Etoken); // Call backend function
  //     if (response.message) {
  //       alert(response.message);
  //       window.location.reload()
  //       FetchData(); // Refresh the list after approval
  //     }
  //     if (response.error) {
  //       alert(response.error)
  //       window.location.reload()
  //       FetchData(); // Refresh the list after approval
  //     }
  //   } catch (error) {
  //     console.error('Error approving bills:', error);
  //     alert('An error occurred while approving bills.');
  //     window.location.reload()
  //   }
  //   setLoading(false); // Stop loader
  // };

  const approveSelected = async () => {
    if (selectedBills.length === 0) {
      alert("No bills selected for approval!");
      return;
    }

    // Defensive numeric parse (treat invalid/missing as 0)
    // const available = Number(TotalPaidCount) || 0;
    // const selectedDemand = Number(data?.SelectedDemandAmount) || 0;

    // if (available < selectedDemand) {
    //   alert(
    //     "Insufficient Available Release Amount. Approval requires Available Release Amount >= Selected Demand Amount.",
    //   );
    //   return;
    // }

    console.log(selectedBills);
    setLoading(true); // Start loader
    // try {
    //   let response = await ApproveBills(selectedBills, Etoken); // Call backend function
    //   if (response.message) {
    //     alert(response.message);
    //     // refresh
    //     FetchData();
    //     window.location.reload();
    //   } else if (response.error) {
    //     alert(response.error);
    //     FetchData();
    //     window.location.reload();
    //   }
    // }
    try {
      let response = await GenerateBankFile(selectedBills, Etoken);

      if (response.message) {
        alert(response.message);

        FetchData();
      } else if (response.error) {
        alert(response.error);

        FetchData();
      }
    } catch (error) {
      console.error("Error approving bills:", error);
      alert("An error occurred while approving bills.");
      // window.location.reload();
    } finally {
      setLoading(false); // Stop loader
    }
  };
  const GetTotalAmountAvailableInBank = async () => {
    let data = await GetTotalAmountAvailbaleInBank();
    console.log(data);
    setBankBalance(data[0]);
    // setCountBalance(data.result1[0])
  };
  let TotalPaidCount = BankBalance.AvailableBalanceinBank;
  console.log(BankBalance);

  const FetchDemandApprovalData = async (e) => {
    e.preventDefault();
    const { ProjectID } = data;
    console.log(ProjectID);

    if (!ProjectID) {
      alert("Required all field priject id and piu name");
      return;
    }

    try {
      let res1 = await GetProjectInfo(ProjectID, "DemandGeneration");
      console.log(res1);

      let result = res1;
      let ans = result.filter((item) => item.ProjectID == ProjectID);

      // setTableData(ans);

      console.log(ans);
    } catch (err) {
      console.log(err);
    }
  };

  const TotalAmount = () => {
    const totalAvaiablereleaseAmount = tableData.reduce(
      (acc, item) => acc + Number(item.BillAmount),
      0,
    );

    setData((prev) => ({
      ...prev,
      AvaiableReleaseAmount: totalAvaiablereleaseAmount,
    }));
  };

  useEffect(() => {
    TotalAmount();
  }, [tableData]);

  const TotalSelectedDemandAmount = (amount) => {
    setData((prev) => ({
      ...prev,
      SelectedDemandAmount:
        Number(prev.SelectedDemandAmount || 0) + Number(amount),
    }));
  };

  // const handleSelectAllChange = (e) => {
  //   const checked = e.target.checked;
  //   setSelectAll(checked);

  //   if (checked) {
  //     const allIds = tableData.map((item) => item.DemandGenerationID);
  //     setSelectedBills(allIds);

  //     // Total of all selected bill amounts
  //     const totalAmount = tableData.reduce((acc, item) => acc + Number(item.BillAmount), 0);
  //     setData((prev) => ({
  //       ...prev,
  //       SelectedDemandAmount: totalAmount
  //     }));
  //   } else {
  //     setSelectedBills([]);
  //     setData((prev) => ({
  //       ...prev,
  //       SelectedDemandAmount: 0
  //     }));
  //   }
  // };

  // const handleSelectAllChange = (e) => {
  //   const checked = e.target.checked;
  //   setSelectAll(checked);

  //   const currentPageBillIDs = currentBills.map((item) => item.DemandGenerationID);

  //   if (checked) {
  //     // Add all currentBills if not already selected
  //     const newSelected = [...new Set([...selectedBills, ...currentPageBillIDs])];
  //     setSelectedBills(newSelected);

  //     // Add only those current page bills that were not already selected
  //     const newlyAdded = currentBills.filter(bill => !selectedBills.includes(bill.DemandGenerationID));
  //     const newAmount = newlyAdded.reduce((acc, item) => acc + Number(item.BillAmount), 0);

  //     setData((prev) => ({
  //       ...prev,
  //       SelectedDemandAmount: prev.SelectedDemandAmount + newAmount
  //     }));
  //   } else {
  //     // Remove only current page bills from selection
  //     const remainingSelected = selectedBills.filter(id => !currentPageBillIDs.includes(id));
  //     setSelectedBills(remainingSelected);

  //     const removedAmount = currentBills.reduce((acc, item) => acc + Number(item.BillAmount), 0);

  //     setData((prev) => ({
  //       ...prev,
  //       SelectedDemandAmount: prev.SelectedDemandAmount - removedAmount
  //     }));
  //   }
  // };

  const handleSelectAllChange = (e) => {
    const checked = e.target.checked;

    // ✅ State department logic
    let validBills = currentBills;

    if (AdminData.Department_Name === "State" && AdminData.RoleID !== 24) {
      validBills = currentBills.filter(
        (item) => uploadedFiles[item.DemandGenerationID],
      );
    }

    // ✅ Check same district before select all
    if (checked && validBills.length > 0) {
      const districtSet = new Set(validBills.map((item) => item.District));

      if (districtSet.size > 1) {
        alert("Please select bills from same district only!");
        return;
      }
    }

    const validBillIDs = validBills.map((item) => item.DemandGenerationID);

    setSelectAll(checked);

    if (checked) {
      const newSelected = [...new Set([...selectedBills, ...validBillIDs])];

      setSelectedBills(newSelected);

      const newlyAdded = validBills.filter(
        (bill) => !selectedBills.includes(bill.DemandGenerationID),
      );

      const newAmount = newlyAdded.reduce(
        (acc, item) => acc + Number(item.BillAmount),
        0,
      );

      setData((prev) => ({
        ...prev,
        SelectedDemandAmount: prev.SelectedDemandAmount + newAmount,
      }));

      // optional alert only for State
      if (
        AdminData.Department_Name === "State" &&
        AdminData.RoleID !== 24 &&
        validBills.length !== currentBills.length
      ) {
        alert("Some bills were skipped because Upload Order file is missing.");
      }
    } else {
      const remainingSelected = selectedBills.filter(
        (id) => !validBillIDs.includes(id),
      );

      setSelectedBills(remainingSelected);

      const removedAmount = validBills.reduce(
        (acc, item) => acc + Number(item.BillAmount),
        0,
      );

      setData((prev) => ({
        ...prev,
        SelectedDemandAmount: prev.SelectedDemandAmount - removedAmount,
      }));
    }
  };
   useEffect(() => {
    let filtered = [...ALLtableData];
    if (data.ProjectID && data.ProjectID !== "All") {
    filtered = filtered.filter(
        item => item.WorkName === data.ProjectID
    );
}
 
if (searchTerm.trim()) {
    const lower = searchTerm.toLowerCase();
 
    filtered = filtered.filter((item) =>
        Object.values(item).some((value) =>
            String(value ?? "")
                .toLowerCase()
                .includes(lower)
        )
    );
}
 
setTableData(filtered);
 
  }, [data.ProjectID,searchTerm, ALLtableData]);

  const DemandDeductionDetailByBillID = async (ID) => {
    try {
      let res = await Getyears("FetchDemandDeductionDetailbyBillID", ID);
      setfetchSpecficDemandDeductionDetail(res);
      setSelectedDemandID(ID);
      setShowSpecific(1);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    const currentPageIDs = currentBills.map((bill) => bill.DemandGenerationID);
    const allSelected = currentPageIDs.every((id) =>
      selectedBills.includes(id),
    );
    setSelectAll(allSelected);
  }, [currentBills, selectedBills]);

  const handleUploadWork = (e, val) => {
    const file = e.target.files[0];

    if (file) {
      setUploadedFiles((prev) => ({
        ...prev,
        [val.DemandGenerationID]: file,
      }));
    }
  };
  console.log("selectedBills", selectedBills);
  const allSelectedBillsHaveFiles =
    selectedBills.length > 0 &&
    currentBills
      .filter((bill) => selectedBills.includes(bill.DemandGenerationID))
      .every((bill) => uploadedFiles[bill.DemandGenerationID]);
  return (
    <>
      {showspecific === 0 && (
        <div
          className="col-12 DemandApprovalPage"
          style={{ backgroundColor: "#eff3f8" }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "10px 4rem",
            }}
          >
            {/* <button className=' px-4 py-2'
              onClick={approveSelected}
              // onClick={(e) => { SetGenerateToken(false) }}
              disabled={selectedBills.length <= 0 ? true : loading}
              style={{
                cursor: selectedBills.length <= 0 ? 'not-allowed' : loading ? 'not-allowed' : 'pointer',
                background: selectedBills.length <= 0 ? (
                  'linear-gradient(to Right,rgba(141, 141, 141, 0.97))'
                ) : ('linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )'), color: 'white',
                fontSize: "16px"
              }}
            ><img src="" style={{ width: '14px', filter: 'brightness(0) invert(1)' }} /> {loading ? 'Processing...' : 'Approve & Pay'}
            </button> */}
            {/* <button className='btn btn-success'>Approve & Pay</button> */}
            {/* <button className='btn mx-2' style={{ backgroundColor: "#B6BAC1" }}>Back</button> */}
            <h4 style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <img src={BillApprovalBlue32} style={{ width: "1.5rem" }} />
              {t("Bill Approval")}
            </h4>
            <button
              onClick={approveSelected}
              disabled={selectedBills.length <= 0 ? true : loading}
              style={{
                color: "white",
                border: "none",
                borderRadius: "20px",
                padding: "8px 20px",
                fontSize: "14px",
                fontWeight: "600",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                cursor: "pointer",
                fontFamily: "sans-serif",
                boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                cursor:
                  selectedBills.length <= 0
                    ? "not-allowed"
                    : loading
                      ? "not-allowed"
                      : "pointer",
                background:
                  selectedBills.length <= 0
                    ? "linear-gradient(to Right,rgba(141, 141, 141, 0.97)"
                    : "linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5)",
                color: "white",
              }}
            >
              <img
                src={ApprovePay32}
                style={{ width: "14px", filter: "brightness(0) invert(1)" }}
              />
              {loading
                ? AdminData.Department_Name === "District" ||
                  AdminData.Department_Name === "State"
                  ? "Processing..."
                  : ""
                : AdminData.Role === "RDD Section Officer"
                  ? t("Generate ECS")
                  : t("Generate ECS")}
            </button>
          </div>

          <div
            style={{
              display: "flex",
              padding: "1rem",
              backgroundColor: "#f1f5f9",
              justifyContent: "space-evenly",
            }}
          >
            {/* Card 1 */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "280px",
                height: "100px",
                backgroundColor: "white",
                borderRadius: "12px",
                boxShadow: "0 0 6px rgba(0,0,0,0.08)",
                borderTop: "3px solid #007bff",
                padding: "15px",
                fontFamily: "sans-serif",
              }}
            >
              <div
                style={{
                  width: "45px",
                  height: "45px",
                  background: "linear-gradient(to bottom, #007bff, #00bfff)",
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "12px",
                }}
              >
                <img
                  src={AvailableReleaseAmount}
                  alt="icon"
                  style={{ width: "45px", height: "45px" }}
                />
              </div>
              <div>
                <div style={{ fontSize: "14px", color: "#6c757d" }}>
                  {t("Available Release Amount :")}
                </div>
                <div
                  style={{
                    fontSize: "16px",
                    fontWeight: "bold",
                    color: "#000",
                  }}
                >
                  {Number(TotalPaidCount).toLocaleString("en-IN")}
                </div>
              </div>
            </div>

            {/* Card 2 */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "280px",
                height: "100px",
                backgroundColor: "white",
                borderRadius: "12px",
                boxShadow: "0 0 6px rgba(0,0,0,0.08)",
                borderTop: "3px solid #007bff",
                padding: "15px",
                fontFamily: "sans-serif",
              }}
            >
              <div
                style={{
                  width: "45px",
                  height: "45px",
                  background: "linear-gradient(to bottom, #007bff, #00bfff)",
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "12px",
                }}
              >
                <img
                  src={SelectedDemandAmount}
                  alt="icon"
                  style={{
                    width: "45px",
                    height: "45px",
                  }}
                />
              </div>
              <div>
                <div style={{ fontSize: "14px", color: "#6c757d" }}>
                  {t("Selected Demand Amount :")}
                </div>
                <div
                  style={{
                    fontSize: "16px",
                    fontWeight: "bold",
                    color: "#000",
                  }}
                >
                  {data?.SelectedDemandAmount
                    ? Number(data.SelectedDemandAmount).toLocaleString("en-IN")
                    : 0}
                </div>
              </div>
            </div>

            {/* Card 3 */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "280px",
                height: "100px",
                backgroundColor: "white",
                borderRadius: "12px",
                boxShadow: "0 0 6px rgba(0,0,0,0.08)",
                borderTop: "3px solid #007bff",
                padding: "15px",
                fontFamily: "sans-serif",
              }}
            >
              <div
                style={{
                  width: "45px",
                  height: "45px",
                  background: "linear-gradient(to bottom, #007bff, #00bfff)",
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "12px",
                }}
              >
                <img
                  src={Balance}
                  alt="icon"
                  style={{
                    width: "45px",
                    height: "45px",
                  }}
                />
              </div>
              <div>
                <div style={{ fontSize: "14px", color: "#6c757d" }}>
                  {t("Balance :")}
                </div>
                <div
                  style={{
                    fontSize: "16px",
                    fontWeight: "bold",
                    color: "#000",
                  }}
                >
                  {Number(
                    TotalPaidCount - data.SelectedDemandAmount,
                  ).toLocaleString("en-IN")}
                </div>
              </div>
            </div>
          </div>
          <div
            className=" col-12 my-3 px-4"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <div
              className="col-12"
              style={{
                padding: "1px",
                borderRadius: "10px",
                background: "linear-gradient(to right, #2196f3, #9c27b0)",
                display: "inline-block",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  background: "linear-gradient(to right, #c0e4f7, #cdd4f8)",
                  padding: "30px 20px",
                  borderRadius: "8px",
                  fontFamily: "sans-serif",
                }}
              >
                <label
                  style={{
                    fontWeight: "600",
                    fontSize: "14px",
                    marginRight: "5px",
                  }}
                >
                  {" "}
                  {t("Work Name")}
                </label>
                <select
                  name="ProjectID"
                  id=""
                  value={data.ProjectID}
                  onChange={HandleChangeData}
                  style={{
                    padding: "12px 12px",
                    borderRadius: "6px",
                    border: "1px solid #ccc",
                    outline: "none",
                    width: "830px",
                    fontSize: "14px",
                  }}
                >
                  <option value="All">{t("Choose Work Name")}</option>
                  {ALLtableData &&
                    ALLtableData.map((val, index) => {
                      return (
                        <option key={index} value={val.WorkName}>
                          {val.WorkName}
                        </option>
                      );
                    })}
                </select>
                {/* Search */}
                  <div style={{ position: "relative", width: "220px" }}>
                    <img
                      src="/Search32.png"
                      alt="Search"
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "10px",
                        transform: "translateY(-50%)",
                        width: "16px",
                        opacity: 0.6,
                      }}
                    />
                    <input
                      type="text"
                      placeholder={t("Search Here")}
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      style={{
                        width: "100%",
                        padding: "8px 12px 8px 32px",
                        border: "1px solid #ccc",
                        borderRadius: "8px",
                        backgroundColor: "#f1f6fc",
                        fontSize: "13px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    />
                  </div>
              </div>
            </div>
          </div>

          <div
            className="m-auto my-3"
            style={{
              width: "97%",
              backgroundColor: "white",
              borderRadius: "10px",
              padding: "20px 20px",
              boxShadow: "0 0 4px rgba(0,0,0,0.1)",
              fontFamily: "sans-serif",
            }}
          >
            <h4 style={{ marginBottom: "15px", fontWeight: "bold" }}>
              {t("Bill Details")}
            </h4>
            <div
              className="col-12 tableContainer2"
              style={{ overflowX: "scroll" }}
            >
              <table
                className="col-12"
                style={{
                  textAlign: "center",
                  width: "100%",
                  borderCollapse: "collapse",
                }}
              >
                <thead>
                  <tr
                    style={{
                      backgroundColor: "#1976d2",
                      color: "white",
                      fontSize: "18px",
                    }}
                  >
                    <th style={{ width: "3%" }}>
                      <input
                        type="checkbox"
                        style={{ height: "1.2rem", width: "1.2rem" }}
                        checked={selectAll}
                        onChange={handleSelectAllChange}
                      />
                    </th>
                    {/* <th style={{ minWidth: "130px", padding: "8px" }}>PIU Name</th> */}
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Demand Number")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Work Name")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("MHUID Number")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Bill Date")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Bill Amount")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Bank Name")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("IFSC")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Account Number")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Vendor Name")}
                    </th>
                    {AdminData.Department_Name == "State" && (
                      <th style={{ minWidth: "130px", padding: "8px" }}>
                        {t("Upload Order")}
                      </th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {currentBills && currentBills.length > 0 ? (
                    currentBills.map((val, index) => {
                      return (
                        <tr key={index} style={{ fontSize: "18px" }}>
                          <td>
                            <input
                              type="checkbox"
                              style={{ height: "1.2rem", width: "1.2rem" }}
                              checked={selectedBills.includes(
                                val.DemandGenerationID,
                              )}
                              onChange={(e) => {
                                handleCheckboxChange(val.DemandGenerationID);
                                // TotalSelectedDemandAmount(e.target.checked ? val.BillAmount : -val.BillAmount);

                                // if unchecking any one, uncheck master
                                if (!e.target.checked) {
                                  setSelectAll(false);
                                }
                              }}
                            />
                          </td>
                          <td>{val.DemandGenerationID}</td>
                           <td>{val.WorkName}</td>
                          <td>{val.BillNumber}</td>
                          <td>{new Date(val.UploadedOn).toLocaleString()}</td>
                          <td>{val.NetPayableAmount}</td>
                          {/* <td
                            onClick={() =>
                              DemandDeductionDetailByBillID(
                                val.DemandGenerationID,
                              )
                            }
                          >
                            <p
                              className="makeitlink my-auto"
                              style={{ textAlign: "center" }}
                            >
                              {Number(val.DeductionAmount).toLocaleString()}
                            </p>
                          </td> */}
                          <td>{val.Bank_Name}</td>
                          <td>{val.Bank_IFSC_Code}</td>
                          <td>{val.Bank_Account_Number}</td>
                          <td>{val.Bank_Account_Holder_Name}</td>
                          {AdminData.Department_Name == "State" && (
                            <td className="py-2">
                              {AdminData.RoleID == 24 ? (
                                // SHOW FILE NAME / LINK
                                val.uploadWork ? (
                                  <p className="my-auto">
                                    <a
                                      href={`${apiurl}/UploadWorkFiles/${val.uploadWork}`}
                                      target="_blank"
                                      // rel="noreferrer"
                                    >
                                      {val.uploadWork}
                                    </a>
                                  </p>
                                ) : (
                                  <p
                                    className="text-danger fw-bold my-auto"
                                    style={{ fontSize: "12px" }}
                                  >
                                    {t("No File")}
                                  </p>
                                )
                              ) : (
                                // SHOW UPLOAD BUTTON
                                <>
                                  <input
                                    type="file"
                                    id={`uploadWork-${index}`}
                                    accept=".pdf,.xls,.xlsx"
                                    style={{ display: "none" }}
                                    onChange={(e) => handleUploadWork(e, val)}
                                  />

                                  <button
                                    type="button"
                                    onClick={() =>
                                      document
                                        .getElementById(`uploadWork-${index}`)
                                        .click()
                                    }
                                    className="m-auto text-center"
                                    style={{
                                      fontWeight: "600",
                                      padding: "8px 6px",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      gap: "0.1rem",
                                      background:
                                        "linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)",
                                      cursor: "pointer",
                                      color: "white",
                                      border: "none",
                                      borderRadius: "5px",
                                    }}
                                  >
                                    {t("Upload Order")}
                                  </button>

                                  {uploadedFiles[val.DemandGenerationID] && (
                                    <p
                                      style={{
                                        fontSize: "12px",
                                        marginTop: "5px",
                                        wordBreak: "break-all",
                                      }}
                                    >
                                      {
                                        uploadedFiles[val.DemandGenerationID]
                                          .name
                                      }
                                    </p>
                                  )}
                                </>
                              )}
                            </td>
                          )}
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={14}>{t("No data found !!")}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                // padding: " 0px 2.5rem",
                height: "3rem",
                alignItems: "center",
              }}
            >
              <div>
                <p style={{ margin: "0px", color: "black" }}>
                  {t("Showing")} {currentBills?.length} {t("of")}{" "}
                  {ALLtableData?.length} {t("entries")}
                </p>
              </div>
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <GooglePagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={setCurrentPage}
                />

                <button
                  onClick={() => {
                    setShowAll(!showAll);
                    setCurrentPage(1);
                  }}
                  style={{
                    border: "none",
                    outline: "none",
                    cursor: "pointer",
                    padding: "8px 16px",
                    borderRadius: "20px",
                    fontSize: "13px",
                    fontWeight: "600",
                    color: "#fff",
                    background: showAll
                      ? "linear-gradient(135deg, #28a745, #20c997)"
                      : "linear-gradient(135deg, #0067ab, #0098d5)",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                    transition: "all 0.3s ease",
                  }}
                >
                  {showAll ? "✓ Showing All" : "View All"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {selectedDemandID && showspecific === 1 && (
        <div
          className="col-12"
          style={{
            backgroundColor: "#EFF3F8",
            height: "90vh",
            overflowX: "hidden",
            overflowY: "scroll",
          }}
        >
          <div className="col-11 m-auto">
            <div className="col-12">
              <div className="col-12 py-3">
                <button
                  className="btn btn-danger px-3 rounded-4 mb-3 mt-3"
                  onClick={() => setShowSpecific(0)}
                >
                  {t("Back")}
                </button>
              </div>

              <div className="col-11 my-4 mx-auto">
                <div className="row">
                  <div className="col-9 my-auto">
                    <h2
                      className="col-10 m-0"
                      style={{
                        color: "#2C78DB",
                        fontWeight: "700",
                        fontSize: "1.4rem",
                      }}
                    >
                      {t("Deduction Data of Bill")} {selectedDemandID}
                    </h2>
                  </div>

                  {/* <div className="col-2 text-end">
                <button className='btn btn-success px-4' onClick={() => exportTableByClassToExcel("DeductionTable", "Deduction.xlsx")}>Download Excel</button>
              </div> */}
                </div>
              </div>
              <div className="col-12 pb-5">
                <div
                  className="m-auto mb-3"
                  style={{
                    backgroundColor: "white",
                    padding: "40px 40px",
                    boxShadow: "0px 0px 5px 1px #E4E8EC",
                    borderRadius: "20px",
                    width: "100%",
                    maxWidth: "100%",
                    overflowX: "hidden",
                  }}
                >
                  <div
                    className="col-12 tableDesign"
                    style={{ background: "#2C78DB", overflowX: "hidden" }}
                  >
                    <table
                      className="m-0 p-0"
                      style={{ width: "100%", borderCollapse: "collapse" }}
                    >
                      <thead>
                        <tr
                          style={{
                            color: "white",
                            border: "none",
                            height: "3rem",
                            fontSize: "12px",
                          }}
                        >
                          <th style={{ width: "10%" }}>{t("Sr No")}</th>
                          <th style={{ width: "45%" }}>
                            {t("Deduction Name")}
                          </th>
                          <th style={{ width: "45%", textAlign: "left" }}>
                            {t("Deduction Amount")}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {fetchSpecificDemandDeductionDetail &&
                        fetchSpecificDemandDeductionDetail.length > 0 ? (
                          <>
                            {fetchSpecificDemandDeductionDetail
                              .filter(
                                (item) =>
                                  item.TypeOfAmount !== "Total Amount Payable",
                              )
                              .map((val, index) => {
                                const bgColor =
                                  index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                return (
                                  <tr
                                    key={index}
                                    style={{
                                      backgroundColor: bgColor,
                                      fontSize: "12px",
                                      fontWeight: "400",
                                    }}
                                  >
                                    <td>{index + 1}</td>
                                    <td>{val.TypeOfAmount}</td>
                                    <td style={{ textAlign: "left" }}>
                                      ₹{" "}
                                      {Number(val.TotalAmount).toLocaleString()}
                                    </td>
                                  </tr>
                                );
                              })}

                            <tr
                              style={{
                                fontWeight: "bold",
                                backgroundColor: "#f0f0f0",
                              }}
                            >
                              <td colSpan={2}>{t("Total Deduction Amount")}</td>
                              <td style={{ textAlign: "left" }}>
                                ₹{" "}
                                {
                                  Number(
                                    fetchSpecificDemandDeductionDetail
                                      .filter(
                                        (item) =>
                                          item.TypeOfAmount !==
                                          "Total Amount Payable",
                                      )
                                      .reduce(
                                        (acc, curr) =>
                                          acc +
                                          parseFloat(curr.TotalAmount || 0),
                                        0,
                                      ),
                                  ).toLocaleString()
                                  // .toFixed(2)
                                }
                              </td>
                            </tr>
                          </>
                        ) : (
                          <tr>
                            <td colSpan={5} className="fw-bold">
                              {t("No Data Found !!")}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default OldECSGeneration;
